import { createContext, ReactNode, useContext, useMemo, useState } from 'react';

// front-end keeps the drawer's open state in redux (store/reducers/menu); this app has no
// store, so the same flag lives in a context.
type MenuContextType = { drawerOpen: boolean; openDrawer: (open: boolean) => void };

const MenuContext = createContext<MenuContextType>({ drawerOpen: true, openDrawer: () => {} });

export const MenuProvider = ({ children }: { children: ReactNode }) => {
  const [drawerOpen, openDrawer] = useState(true);
  const value = useMemo(() => ({ drawerOpen, openDrawer }), [drawerOpen]);
  return <MenuContext.Provider value={value}>{children}</MenuContext.Provider>;
};

const useMenu = () => useContext(MenuContext);

export default useMenu;
